import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Trash2 } from "lucide-react";

export function Categories() {
  const [cats, setCats] = useState([]);
  const [f, setF] = useState({ name: "", description: "" });
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/categories").then(r => setCats(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!f.name) { toast.error("Category name required"); return; }
    try {
      if (editing) {
        await api.patch(`/admin/categories/${editing.id || editing.name}`, f);
        toast.success("Updated");
      } else {
        await api.post("/admin/categories", f);
        toast.success("Created");
      }
      setF({ name: "", description: "" });
      setEditing(null);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const del = async (c) => {
    if (!confirm(`Delete category "${c.name}"?`)) return;
    try {
      await api.delete(`/admin/categories/${c.id || c.name}`);
      toast.success("Deleted");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <div>
      <h1 className="font-serif text-4xl mb-1">Categories</h1>
      <div className="overline text-white/40 mb-8">Custom collection groupings</div>
      <div className="surface p-5 mb-6">
        <div className="overline text-white/50 mb-3">{editing ? "Edit Category" : "New Category"}</div>
        <div className="grid md:grid-cols-3 gap-3">
          <input placeholder="Category name" data-testid="category-name" className="bg-black/40 border border-white/10 px-3 py-2 text-sm" value={f.name} onChange={e => setF({ ...f, name: e.target.value })}/>
          <input placeholder="Description (optional)" className="bg-black/40 border border-white/10 px-3 py-2 text-sm md:col-span-2" value={f.description} onChange={e => setF({ ...f, description: e.target.value })}/>
        </div>
        <div className="mt-3 flex gap-3">
          <button onClick={save} data-testid="category-save" className="bg-white text-black px-5 py-2 text-xs uppercase tracking-widest">{editing ? "Save" : "Create"}</button>
          {editing && <button onClick={() => { setEditing(null); setF({ name: "", description: "" }); }} className="border border-white/20 px-5 py-2 text-xs uppercase tracking-widest text-white/70">Cancel</button>}
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        {cats.map(c => (
          <div key={c.id || c.name} className="surface p-5 flex justify-between items-start" data-testid={`cat-${c.name}`}>
            <div>
              <div className="font-serif text-xl">{c.name}</div>
              {c.description && <div className="text-xs text-white/50 mt-1">{c.description}</div>}
            </div>
            <div className="flex gap-2">
              <button onClick={() => { setEditing(c); setF({ name: c.name, description: c.description || "" }); }} className="px-2 py-1 text-[10px] uppercase tracking-widest bg-white/10 text-white/70">Edit</button>
              <button onClick={() => del(c)} className="px-2 py-1 text-[10px] uppercase tracking-widest bg-white/5 text-red-400 hover:bg-red-900/30"><Trash2 size={12}/></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

